import type { ReactNode } from "react"
import { useEffect, useRef, useState } from "react"
import styled from "styled-components"

type RatioElementProps = {
  ratio: number
  children: ReactNode
  css?: boolean
  debug?: boolean
}

const DEFAULT_MOBILE_WIDTH = 360

const StyledDiv = styled.div<{ height: number }>`
  display: block;
  width: 100%;
  position: relative;
  min-height: 1px;
  height: ${(p) => p.height + "px"};
`

const StyledCssDiv = styled.div<{ ratio: number }>`
  display: block;
  width: 100%;
  position: relative;
  height: 0;
  padding-bottom: calc(100% / ${(p) => p.ratio});
  > img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    object-fit: cover;
  }
`

const RatioElement = ({
  ratio = 1,
  children,
  css,
  debug = false,
}: RatioElementProps) => {
  const [height, setHeight] = useState<number>(DEFAULT_MOBILE_WIDTH / ratio)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (css) return

    const listener = () => {
      if (ref.current) {
        // eslint-disable-next-line no-debugger
        if (debug) debugger
        setHeight(ref.current.clientWidth / ratio)
      }
    }
    process.browser ? listener() : setHeight(DEFAULT_MOBILE_WIDTH / ratio)
    window.addEventListener("resize", listener)
    return () => window.removeEventListener("resize", listener)
  }, [ratio, css, debug])

  return css ? (
    <StyledCssDiv ratio={ratio}>{children}</StyledCssDiv>
  ) : (
    <StyledDiv height={height} ref={ref}>
      {children}
    </StyledDiv>
  )
}

export default RatioElement
